import { render, staticRenderFns } from "./ExhibitorRecommendationsView.vue?vue&type=template&id=a4106e5a"
import script from "./ExhibitorRecommendationsView.vue?vue&type=script&lang=js"
export * from "./ExhibitorRecommendationsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports